import { graphql } from "@/lib/gql/__generated__";

export const RoomArticleUpdate_DesignPage_Mutation = graphql(`
	mutation RoomArticleUpdate_DesignPage($input: RoomArticleInput!) {
		roomArticleUpdate(input: $input) {
			userErrors
			room {
				id
				hotelID
				roomID
				inSale
				isDormitoryType
				maxRoomNum
				capacityPeopleMaximum
				capacityAdultMaximum
				capacityKidsMaximum
				isKidsUnavailable
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				name
				catchCopy
				description
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				saleTypeForPlan
				requiredPrepMillisecond
				amenities
				beds {
					bedType
					bedNum
				}
				roomSize
				overSiteControllerPeopleNum {
					prices {
						upperNum
						price {
							currencyType
							amount
						}
					}
					availableWeekDays
				}
				isExtendSiteControllerPeopleNum
				address {
					nationality
					postalCode
					state
					pref
					city
					town
					other
				}
				geoLocation {
					lat
					lon
				}
				availablePlanIDs
			}
		}
	}
`);
